import { Button, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { ConfirmDialog } from '../../../components/Dialog/ConfirmDialog/ConfirmDialog';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { CompanyPreferenceSelector } from './CompanyPreferenceSelector';
import { DetailsConfigActions } from './DetailsConfigActions';
import { ExitConfigBlocker } from './ExitConfigBlocker';
import { FieldSelectionConfig } from './FieldSelectionConfig';
import { useKpiDisplayConfig } from './useKpiDisplayConfig';

const kpiConfigLink = `/${ROUTES.ADMIN_PANEL}/${ROUTES.CONFIG}/${ROUTES.CONFIG_KPI}`;

export function KpiDisplayConfig() {
  const {
    quantitativeKpis,
    allFields,
    selectedFields,
    editStatus,
    selectedCompanyId,
    pendingSwitch,
    onAddField,
    onRemoveField,
    onFormatChange,
    onSave,
    onReset,
    onDiscard,
    onCompanyChange,
    onSaveAndSwitch,
    onDiscardAndSwitch,
    onCancelSwitch,
  } = useKpiDisplayConfig();

  if (!quantitativeKpis) {
    return null;
  }

  return (
    <Stack gap='1rem' py='1rem' height='calc(100dvh - 8rem)' overflow='hidden'>
      <ExitConfigBlocker onSave={onSave} onLeave={onDiscard} editStatus={editStatus} />
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Stack direction='row' alignItems='center' gap='0.5rem'>
          <Typography variant='h4'>KPI Display for</Typography>
          <CompanyPreferenceSelector
            selectedCompanyId={selectedCompanyId}
            onCompanyChange={onCompanyChange}
          />
        </Stack>
        <DetailsConfigActions
          save={{ handler: onSave, disabled: editStatus !== 'modified' }}
          reset={{ handler: onReset }}
        />
      </Stack>
      <Typography variant='body2' color='text.secondary'>
        Select which KPIs to display in the Financials grid and customize their formatting. Sort order and
        grouping are configured in{' '}
        <Link component={RouterLink} to={kpiConfigLink}>
          Portfolio Configuration &gt; KPIs
        </Link>
        .
      </Typography>
      <FieldSelectionConfig
        allFields={allFields}
        onAddField={onAddField}
        onRemoveField={onRemoveField}
        selectedFields={selectedFields}
        onFormatChange={onFormatChange}
      />
      <ConfirmDialog
        open={pendingSwitch !== undefined}
        title='Unsaved Changes'
        onClose={onCancelSwitch}
        actionButtons={
          <>
            <Button variant='contained' color='secondary' onClick={onSaveAndSwitch}>
              Save and Switch
            </Button>
            <Button variant='outlined' color='secondary' onClick={onDiscardAndSwitch}>
              Discard Changes
            </Button>
            <Button variant='outlined' color='secondary' onClick={onCancelSwitch}>
              Cancel
            </Button>
          </>
        }
      >
        <Typography>You have unsaved changes. Would you like to save before switching?</Typography>
      </ConfirmDialog>
    </Stack>
  );
}
